import { render } from "./Logo.vue?vue&type=template&id=20c56ee0&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=20c56ee0&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/得乐线上化/dele-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c56ee0"]])

export default __exports__